"use strict";

const IndcomToDoController = function () {
  const clearFlaggedInspections = async function (facilityIds) {
    try {
      await ToDoFunctions.showConfirmClearToDoListConfirm(facilityIds.length, {
        selectedToDosName: "flagged inspection",
        confirmButton: "Clear Flagged Inspections",
      });
    } catch (e) {
      return;
    }

    await ApiCalls.indcomToDoClearFlaggedInspections(facilityIds);

    IndcomFacilityGeoServerLayer.invalidateLayerData();
  };

  return {
    clearFlaggedInspections,
  };
};

module.exports = IndcomToDoController();

const ApiCalls = require("../apiCalls");
const ToDoFunctions = require("../mapFunctions/toDoFunctions");
const IndcomFacilityGeoServerLayer = require("./indcomFacilityGeoServerLayer");
